import React from 'react';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import StatsWidget from '@rio-cloud/rio-uikit/lib/es/StatsWidget';

const CampaignCardSkeleton: React.FC = () => {
    return (
        <div className='col-4 margin-bottom-20'>
            <StatsWidget>
                <StatsWidget.Body className='display-flex flex-column align-items-start gap-10 margin-top-15'>
                    <ContentLoader height={120}>
                        <rect x='0' y='0' rx='3' ry='3' width='100%' height='20'/>
                        <rect x='0' y='30' rx='3' ry='3' width='40%' height='15'/>
                        <rect x='0' y='55' rx='3' ry='3' width='80%' height='15'/>
                        <rect x='0' y='80' rx='3' ry='3' width='100%' height='10'/>
                    </ContentLoader>
                </StatsWidget.Body>
            </StatsWidget>
        </div>
    );

};

export default CampaignCardSkeleton;
